import { Component, inject } from "@angular/core";
import { CoreLink, CorePopover, SvsModalService, SvsPopoverOptionListComponent } from "@svs/angular";
import { TosModalComponent } from "../../../@shared/tos-modal/tos-modal.component";

@Component({
  selector: "app-landing-disclaimer",
  imports: [
    CorePopover,
    SvsPopoverOptionListComponent,
    CoreLink,

  ],
  templateUrl: "./landing-disclaimer.component.html",
  styleUrl: "./landing-disclaimer.component.scss",
})
export class LandingDisclaimerComponent {
  private readonly modal = inject(SvsModalService);

  links = [
    { name: "Datenschutzrichtlinien", href: "https://www.svs.at/cdscontent/?contentid=10007.816815&portal=svsportal" },
    {
      name: "Nutzungsbedingungen", onClick: () => {
        this.modal.open(TosModalComponent);
      },
    },
    { name: "Impressum", href: "https://www.svs.at/cdscontent/?contentid=10007.816865&portal=svsportal" },
  ];
  offset = { mainAxis: 8 };

}
